module.exports = __webpack_public_path__ + "media/images/icon/icons8-Circled Dot-39376ce4ce1e25f6b87e2814da32e206.png";